import * as React from "react"
import * as styles from "./styles.module.scss"
import ReviewRating from "../ReviewRating"

const ReviewRatings: React.FC = () => {
  return (
    <div className={styles.reviewRatings}>
      <div className={styles.item}>
        <ReviewRating
          provider="google"
          initialRating={4.3}
          finalRating={4.5}
          count={71}
        />
      </div>
      <div className={styles.item}>
        <ReviewRating
          provider="bankrate"
          initialRating={4.2}
          finalRating={4.6}
          count={79}
        />
      </div>
    </div>
  )
}

export default ReviewRatings
